import React from "react";
import { Form } from "react-bootstrap";
import { FormikErrors, FormikHandlers, FormikTouched } from "formik";
import type { HTMLInputMaskElement, InputMask } from "imask";
import MaskedInput from "components/MaskedInput";

interface EinFormValues {
  ein: string;
  confirmEin: string;
}

interface EinFormProps {
  handleChange: FormikHandlers["handleChange"];
  handleBlur: FormikHandlers["handleBlur"];
  values: EinFormValues;
  touched: FormikTouched<EinFormValues>;
  errors: FormikErrors<EinFormValues>;
}

const EinForm = ({
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
}: EinFormProps) => {
  return (
    <>
      <Form.Group className="mb-3" controlId="formEinField">
        <Form.Label>New EIN</Form.Label>
        <Form.Control
          as={MaskedInput}
          mask="00-0000000"
          name="ein"
          placeholder="12-3456789"
          value={values.ein}
          onAccept={(val: string, mask: InputMask) =>
            // mask.el is typed as the base MaskElement (no `.input`); at runtime
            // it is always the HTMLInputMaskElement bridging the underlying
            // <input>. The synthetic { target } shape is what Formik's
            // handleChange reads off the event.
            handleChange({
              target: {
                name: (mask.el as HTMLInputMaskElement).input.name,
                value: val,
              },
            } as unknown as React.ChangeEvent<HTMLInputElement>)
          }
          onBlur={handleBlur}
          isInvalid={touched.ein && !!errors.ein}
          isValid={touched.ein && !errors.ein}
        />
        <Form.Control.Feedback type="invalid">
          {errors.ein}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formConfirmEinField">
        <Form.Label>Confirm EIN</Form.Label>
        <Form.Control
          as={MaskedInput}
          mask="00-0000000"
          name="confirmEin"
          placeholder="12-3456789"
          value={values.confirmEin}
          onAccept={(val: string, mask: InputMask) =>
            // mask.el is typed as the base MaskElement (no `.input`); at runtime
            // it is always the HTMLInputMaskElement bridging the underlying
            // <input>. The synthetic { target } shape is what Formik's
            // handleChange reads off the event.
            handleChange({
              target: {
                name: (mask.el as HTMLInputMaskElement).input.name,
                value: val,
              },
            } as unknown as React.ChangeEvent<HTMLInputElement>)
          }
          onBlur={handleBlur}
          isInvalid={touched.confirmEin && !!errors.confirmEin}
          isValid={touched.confirmEin && !errors.confirmEin}
        />
        <Form.Control.Feedback type="invalid">
          {errors.confirmEin}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

export default EinForm;
